// app/javascript/controllers/email_validator_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["field", "errorMessage"]

  connect() {
  }

  validate() {
    this.fieldTarget.value = this.fieldTarget.value.trim();
    const email = this.fieldTarget.value;
    // Simple regex for email validation
    const regex = /^[a-zA-Z0-9._\+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;

    if (!regex.test(email)) {
      this.fieldTarget.classList.add('is-danger');
      this.errorMessageTarget.textContent = "Ungültige E-Mail-Adresse";
      return false;
    } else {
      this.fieldTarget.classList.remove('is-danger');
      this.errorMessageTarget.textContent = ""; // Clear error message
      return true;
    }
  }

  blur() {
    this.element.removeEventListener('input', this.validate);
    const result = this.validate();
    this.element.addEventListener('input', () => {
      this.validate();
    });
    return result
  }
}
